import React, { useState } from 'react';

const GalleryDashboard = () => {
  const [activeTab, setActiveTab] = useState('photos');
  const [items, setItems] = useState({
    photos: [
      { id: 1, title: 'Gallery Image 1', description: 'Company moment', src: '' },
      { id: 2, title: 'Gallery Image 2', description: 'Team event', src: '' }
    ],
    videos: []
  });
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ title: '', description: '', src: '' });

  const handleAdd = () => {
    const newItem = {
      id: Date.now(),
      ...formData
    };
    setItems(prev => ({
      ...prev,
      [activeTab]: [...prev[activeTab], newItem]
    }));
    setFormData({ title: '', description: '', src: '' });
  };

  const handleEdit = (item) => {
    setEditingItem(item.id);
    setFormData({ title: item.title, description: item.description, src: item.src });
  };

  const handleUpdate = () => {
    setItems(prev => ({
      ...prev,
      [activeTab]: prev[activeTab].map(item => 
        item.id === editingItem 
          ? { ...item, ...formData }
          : item
      )
    }));
    setEditingItem(null);
    setFormData({ title: '', description: '', src: '' });
  };

  const handleDelete = (id) => {
    if (window.confirm('Delete this item?')) {
      setItems(prev => ({
        ...prev,
        [activeTab]: prev[activeTab].filter(item => item.id !== id)
      }));
    }
  };

  const handleCancel = () => {
    setEditingItem(null);
    setFormData({ title: '', description: '', src: '' });
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Gallery Management</h1>
        <p style={styles.subtitle}>Add and manage photos and videos</p>
      </div>

      <div style={styles.tabContainer}>
        <button 
          style={{...styles.tab, ...(activeTab === 'photos' ? styles.activeTab : {})}}
          onClick={() => setActiveTab('photos')}
        >
          Photos
        </button>
        <button 
          style={{...styles.tab, ...(activeTab === 'videos' ? styles.activeTab : {})}}
          onClick={() => setActiveTab('videos')}
        >
          Videos
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.formSection}>
          <h2 style={styles.sectionTitle}>
            {editingItem ? 'Edit Item' : 'Add New Item'}
          </h2>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Title</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              style={styles.input}
              placeholder="Enter title"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Description</label>
            <input
              type="text"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              style={styles.input}
              placeholder="Enter description"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
              {activeTab === 'photos' ? 'Image URL' : 'Video URL'}
            </label>
            <input
              type="text"
              value={formData.src}
              onChange={(e) => setFormData({...formData, src: e.target.value})}
              style={styles.input}
              placeholder={`Enter ${activeTab === 'photos' ? 'image' : 'video'} URL`}
            />
          </div>

          <div style={styles.buttonGroup}>
            {editingItem ? (
              <>
                <button onClick={handleUpdate} style={styles.btnPrimary}>
                  Update
                </button>
                <button onClick={handleCancel} style={styles.btnSecondary}>
                  Cancel
                </button>
              </>
            ) : (
              <button onClick={handleAdd} style={styles.btnPrimary}>
                Add {activeTab === 'photos' ? 'Photo' : 'Video'}
              </button>
            )}
          </div>
        </div>

        <div style={styles.listSection}>
          <h2 style={styles.sectionTitle}>
            Current {activeTab === 'photos' ? 'Photos' : 'Videos'} ({items[activeTab].length})
          </h2>
          
          <div style={styles.itemsList}>
            {items[activeTab].length === 0 ? (
              <p style={styles.emptyText}>No items yet. Add your first one above.</p>
            ) : (
              items[activeTab].map(item => (
                <div key={item.id} style={styles.itemCard}>
                  <div style={styles.itemInfo}>
                    <h3 style={styles.itemTitle}>{item.title}</h3>
                    <p style={styles.itemDesc}>{item.description}</p>
                    {item.src && (
                      <p style={styles.itemUrl}>
                        {item.src.substring(0, 50)}...
                      </p>
                    )}
                  </div>
                  <div style={styles.itemActions}>
                    <button 
                      onClick={() => handleEdit(item)}
                      style={styles.btnEdit}
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)}
                      style={styles.btnDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#000',
    color: '#fff',
    padding: '40px 20px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '700',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '1.1rem',
    opacity: 0.8,
    fontWeight: '300',
  },
  tabContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '40px',
  },
  tab: {
    padding: '10px 30px',
    background: 'rgba(255, 255, 255, 0.15)',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    color: '#fff',
    borderRadius: '50px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  activeTab: {
    background: '#fff',
    color: '#000',
    borderColor: '#fff',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '40px',
  },
  formSection: {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '15px',
    padding: '30px',
  },
  listSection: {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '15px',
    padding: '30px',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    marginBottom: '25px',
    fontWeight: '600',
  },
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '0.95rem',
    opacity: 0.9,
  },
  input: {
    width: '100%',
    padding: '12px 15px',
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '1rem',
    outline: 'none',
    transition: 'all 0.3s ease',
  },
  buttonGroup: {
    display: 'flex',
    gap: '10px',
    marginTop: '25px',
  },
  btnPrimary: {
    flex: 1,
    padding: '12px 25px',
    background: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'all 0.3s ease',
  },
  btnSecondary: {
    flex: 1,
    padding: '12px 25px',
    background: 'transparent',
    color: '#fff',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'all 0.3s ease',
  },
  itemsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxHeight: '600px',
    overflowY: 'auto',
  },
  itemCard: {
    background: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '15px',
  },
  itemInfo: {
    flex: 1,
  },
  itemTitle: {
    fontSize: '1.1rem',
    marginBottom: '5px',
    fontWeight: '600',
  },
  itemDesc: {
    fontSize: '0.9rem',
    opacity: 0.8,
    marginBottom: '5px',
  },
  itemUrl: {
    fontSize: '0.75rem',
    opacity: 0.6,
    fontFamily: 'monospace',
  },
  itemActions: {
    display: 'flex',
    gap: '8px',
  },
  btnEdit: {
    padding: '8px 16px',
    background: 'rgba(255, 255, 255, 0.15)',
    color: '#fff',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    transition: 'all 0.3s ease',
  },
  btnDelete: {
    padding: '8px 16px',
    background: 'rgba(255, 100, 100, 0.2)',
    color: '#ff6b6b',
    border: '1px solid rgba(255, 100, 100, 0.4)',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    transition: 'all 0.3s ease',
  },
  emptyText: {
    textAlign: 'center',
    opacity: 0.6,
    fontSize: '0.95rem',
    padding: '40px 20px',
  },
};

export default GalleryDashboard;